import React from 'react'
import { ControlledSelectField } from '../ControlledSelectField'

export const RangeSelect = ({
  name = 'range',
  label = 'Follower Range',
  hasAny = false,
  disabled = false
}) => {
  const menuItems = [
    ...(hasAny ? [{ value: 'any', label: 'Any' }] : []),
    { value: 'mega', label: '1M and up' },
    { value: 'macro', label: '100k and up' },
    { value: 'micro', label: '10k and up' },
    { value: 'nano', label: '2,000 and up' },
    { value: 'emerging', label: 'Any' }
  ]

  return (
    <ControlledSelectField
      name={name}
      label={label}
      menuItems={menuItems}
      disabled={disabled}
    />
  )
}
